/* eslint-disable max-len, sort-keys */
import { isBoolean } from 'lodash';

import { AccommodationsService, dynamicSatelliteManager } from 'sat-core';

const DEFAULT_ASSESSMENT_TOGGLES = {
  // toggles marked as true will appear in the order shown here
  basicCalculatorToggle: true,
  scientificCalculatorToggle: false,
  graphingCalculatorToggle: false,
  textToSpeechToggle: true,
  dictionaryToggle: false,
  translationToggle: true,
  contentLanguageToggle: true,
  spellcheckerToggle: false
};

const DEFAULT_LESSON_TOGGLES = {
  // toggles marked as true will appear in the order shown here
  basicCalculatorToggle: true,
  scientificCalculatorToggle: false,
  graphingCalculatorToggle: false,
  textToSpeechToggle: true,
  dictionaryToggle: true,
  translationToggle: true,
  spellcheckerToggle: false
};

/**
 * Toggle visibility comes from the satellite layout. Column order stays on the
 * defaults unless `respectToggleOrder` is true, in which case keys listed in
 * the layout appear first, in that order.
 */
const resolveSectionToggles = (defaultToggles, overrideToggles = {}, respectToggleOrder = false) => {
  const defaultKeys = Object.keys(defaultToggles);
  const overrideKeys = Object.keys(overrideToggles).filter((toggleKey) => defaultKeys.includes(toggleKey));
  const orderedKeys = respectToggleOrder && overrideKeys.length
    ? [...overrideKeys, ...defaultKeys.filter((toggleKey) => !overrideKeys.includes(toggleKey))]
    : defaultKeys;

  return orderedKeys.reduce((toggles, toggleKey) => {
    const overrideValue = overrideToggles[toggleKey];
    toggles[toggleKey] = isBoolean(overrideValue) ? overrideValue : defaultToggles[toggleKey];
    return toggles;
  }, {});
};

AccommodationsService.ACCOMMODATIONS_CONFIG = () => {
  const accommodationsConfigOverride = (
    dynamicSatelliteManager?.dynamicSatelliteLayoutConfig?.satelliteIndexFlagOverrides?.accommodationsConfig
  );

  const config = accommodationsConfigOverride;

  const assessmentToggles = config?.assessmentSection?.toggles || {};

  const lessonToggles = config?.lessonSection?.toggles || {};

  const respectToggleOrder = config?.respectToggleOrder === true;

  return {
    assessmentSection: {
      // `show` overrides all other assessment options if false
      show: isBoolean(config?.assessmentSection?.show) ? config.assessmentSection.show : true,
      toggles: resolveSectionToggles(DEFAULT_ASSESSMENT_TOGGLES, assessmentToggles, respectToggleOrder)
    },
    lessonSection: {
      // `show` overrides all other lesson options if false
      show: isBoolean(config?.lessonSection?.show) ? config.lessonSection.show : true,
      toggles: resolveSectionToggles(DEFAULT_LESSON_TOGGLES, lessonToggles, respectToggleOrder)
    },
    cellDividerClassName: typeof config?.cellDividerClassName === 'string' ? config.cellDividerClassName : 'section-divider',
    showTopHeader: isBoolean(config?.showTopHeader) ? config.showTopHeader : true,
    tableHeaderFontSize: typeof config?.tableHeaderFontSize === 'string' ? config.tableHeaderFontSize : 'inherit',
    toggleGroups: Array?.isArray(config?.toggleGroups) ? config?.toggleGroups : [],
    treatAllSectionsAsOne: isBoolean(config?.treatAllSectionsAsOne) ? config.treatAllSectionsAsOne : false
  };
};
